/**
 * -------------------------------------------------------------------------------------------------------------------
 * UTILITIES
 * -------------------------------------------------------------------------------------------------------------------
 */

/**
 * @param {String} nodes - ClassList with DOM reference
 * @param {HTMLElement} parent - Parent of nodes
 * @returns {Array} Array of nodes in DOM
 */
const $Qll = (
  nodes,
  parent
) => [...(parent || document).querySelectorAll(nodes)]

/**
 *
 * @param {HTMLElement} node - ClassName with DOM reference
 * @param {HTMLElement} parent - Parent of nodes
 * @returns {Node} Node in DOM
 */
const $Q = (node, parent) => (parent || document).querySelector(node)

/**
 * -------------------------------------------------------------------------------------------------------------------
 * COMPONENTS
 * -------------------------------------------------------------------------------------------------------------------
 */

/**
 * Dropdown open scope
 */
function dropdownScope () {
  const marketElements = $Qll('.localization-dropdown-js')
  
  marketElements.forEach((mainDropdown) => {
    const mainButton = $Q('.localization-btn-js', mainDropdown)
  
    mainButton.addEventListener('click', () => {
      mainDropdown.classList.toggle('open')
    })
  
    document.addEventListener('click', (event) => {
      if (!mainDropdown.contains(event.target)) {
        mainDropdown.classList.remove('open')
        subDropdowns.forEach((subDropdown) => {
          subDropdown.classList.remove('open')
        })
      }
    })
  })
}

/**
 * Product card image gallery — arrow navigation + boundary handling.
 * Mobile swipe is handled natively via CSS scroll-snap on the slides container.
 */
function initProductCardGallery (figure) {
  if (figure.dataset.galleryReady === 'true') return
  figure.dataset.galleryReady = 'true'

  const slides = $Q('[data-product-card-slides]', figure)
  const prevBtn = $Q('[data-product-card-nav="prev"]', figure)
  const nextBtn = $Q('[data-product-card-nav="next"]', figure)

  if (!slides || (!prevBtn && !nextBtn)) return

  const updateButtons = () => {
    const max = slides.scrollWidth - slides.clientWidth
    const x = slides.scrollLeft

    if (prevBtn) prevBtn.hidden = x <= 1
    if (nextBtn) nextBtn.hidden = x >= max - 1
  }

  const scrollByOne = (direction) => {
    const slide = $Q('.product-card__slide', slides)
    const step = slide ? slide.getBoundingClientRect().width : slides.clientWidth
    slides.scrollBy({ left: direction * step, behavior: 'smooth' })
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', (event) => {
      event.preventDefault()
      event.stopPropagation()
      scrollByOne(-1)
    })
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', (event) => {
      event.preventDefault()
      event.stopPropagation()
      scrollByOne(1)
    })
  }

  slides.addEventListener('scroll', updateButtons, { passive: true })
  window.addEventListener('resize', updateButtons)
  updateButtons()
}

function productCardGalleries () {
  $Qll('[data-product-card-figure]').forEach(initProductCardGallery)

  // Re-init for AJAX-injected cards (facet filters, pagination, quick view, etc.)
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return
        if (node.matches && node.matches('[data-product-card-figure]')) {
          initProductCardGallery(node)
        }
        if (node.querySelectorAll) {
          node.querySelectorAll('[data-product-card-figure]').forEach(initProductCardGallery)
        }
      })
    })
  })

  observer.observe(document.body, { childList: true, subtree: true })
}

/**
 * -------------------------------------------------------------------------------------------------------------------
 * INVOKES
 * -------------------------------------------------------------------------------------------------------------------
 */

function initCustom () {
  dropdownScope()
  productCardGalleries()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCustom)
} else {
  initCustom()
}